import { NgModule, InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppConfig } from '../core/config-models/app-config.model';
declare var require: any;

export const appConfig = require(`${environment.appConfigFile}`) as AppConfig;
export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');

@NgModule({
  providers: [{ provide: APP_CONFIG, useValue: appConfig }]
})
export class AppConfigModule {}
